import { LoadingOverlay } from '@/components/loading-overlay/loading-overlay';
import { startCase } from 'lodash';
import React from 'react';
import { IDashboardSummaryShipment } from '@/modules/dashboard/summary/model/summary';

const DashboardSummaryShipment: React.FC<{
  shipmentData: IDashboardSummaryShipment,
  isLoading: boolean,
}> = (props) => (
  <div className="bg-white p-5 rounded-xl mb-5">
    <LoadingOverlay isLoading={props?.isLoading}>
      <span className="text-lg font-bold">Pengiriman</span>
      <div className="grid grid-cols-4 gap-4 mt-4 text-center">
        <div className="shadow-md rounded-lg border border-gray-200">
          <div className="text-sm font-bold bg-gray-100 rounded-t-lg p-2">Total Order</div>
          <div className="text-2xl font-bold pt-6 pb-6 text-sky-500">{props?.shipmentData?.total_order}</div>
        </div>
        {props?.shipmentData?.statuses?.map((shipment, index) => (
          <div key={index} className="shadow-md rounded-lg border border-gray-200">
            <div className="text-sm font-bold bg-gray-100 rounded-t-lg p-2">{startCase(shipment?.status)}</div>
            <div className="text-2xl font-bold pt-6 pb-6 text-sky-500">{shipment?.total_order}</div>
          </div>
        ))}
      </div>
    </LoadingOverlay>
  </div >
);

export default DashboardSummaryShipment;
